/* Storefront theme: core scripts. Each feature only runs when its markup is on the page. */
(function () {
  'use strict';
  var d = document;
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Video modal (fullscreen player) ---------- */
  var modal = d.getElementById('VideoModal');
  var modalBody = modal && modal.querySelector('[data-vmodal-body]');

  function openVideo(srcVideo) {
    if (!modal || !srcVideo) return;
    var v = d.createElement('video');
    v.setAttribute('playsinline', '');
    v.controls = true;
    v.autoplay = true;
    v.loop = true;
    v.setAttribute('controlslist', 'nodownload noplaybackrate');
    v.setAttribute('disablepictureinpicture', '');
    if (srcVideo.poster) v.poster = srcVideo.poster;
    var sources = srcVideo.querySelectorAll('source');
    if (sources.length) {
      sources.forEach(function (s) { v.appendChild(s.cloneNode()); });
    } else if (srcVideo.currentSrc || srcVideo.src) {
      v.src = srcVideo.currentSrc || srcVideo.src;
    }
    modalBody.innerHTML = '';
    modalBody.appendChild(v);
    modal.hidden = false;
    d.documentElement.classList.add('modal-open');
    v.muted = false;
    var p = v.play();
    if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
    modal.querySelector('[data-vmodal-close]').focus();
  }

  function closeVideo() {
    if (!modal || modal.hidden) return;
    var v = modalBody.querySelector('video');
    if (v) { v.pause(); v.removeAttribute('src'); v.load(); }
    modalBody.innerHTML = '';
    modal.hidden = true;
    d.documentElement.classList.remove('modal-open');
  }

  /* TikTok posts (pasted as an embed code) play in TikTok's own player */
  function openTikTok(id) {
    if (!modal || !/^\d{6,25}$/.test(id)) return;
    var f = d.createElement('iframe');
    f.src = 'https://www.tiktok.com/player/v1/' + id + '?autoplay=1&loop=1&music_info=0&description=0&rel=0&native_context_menu=0&closed_caption=0';
    f.allow = 'autoplay; fullscreen; encrypted-media; picture-in-picture';
    f.setAttribute('allowfullscreen', '');
    f.title = 'TikTok video';
    modalBody.innerHTML = '';
    modalBody.appendChild(f);
    modal.hidden = false;
    d.documentElement.classList.add('modal-open');
    modal.querySelector('[data-vmodal-close]').focus();
  }

  window.SFVideo = { open: openVideo, close: closeVideo, tiktok: openTikTok };

  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-vmodal-close]')) closeVideo();
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeVideo(); });
  }

  d.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-video-open]');
    if (!trigger) return;
    e.preventDefault();
    var tt = trigger.getAttribute('data-tiktok');
    if (tt) openTikTok(tt);
    else openVideo(trigger.querySelector('video'));
  });

  /* ---------- Muted previews: play only while visible ---------- */
  function initAutoplay(root) {
    var vids = $$('[data-autoplay] video, video[data-autoplay]', root);
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.play().catch(function () {}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (v.preload === 'none') v.preload = 'metadata';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { rootMargin: '120px 0px', threshold: 0.15 });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  }

  /* ---------- TikTok previews: muted, playing only while on screen ---------- */
  function ttSend(frame, type) {
    if (frame.contentWindow) frame.contentWindow.postMessage({ type: type, value: null, 'x-tiktok-player': true }, '*');
  }
  function initTikTok(root) {
    var frames = $$('iframe[data-tt-preview]', root);
    if (!frames.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        en.target._ttOn = en.isIntersecting;
        ttSend(en.target, en.isIntersecting ? 'play' : 'pause');
      });
    }, { rootMargin: '120px 0px', threshold: 0.15 });
    frames.forEach(function (f) { io.observe(f); });
  }
  // TikTok always starts muted: the full-screen player gets its sound once it plays,
  // and a preview that finishes loading while off screen waits paused
  window.addEventListener('message', function (e) {
    if (!/^https:\/\/([a-z0-9-]+\.)?tiktok\.com$/.test(e.origin)) return;
    var m = e.data;
    if (typeof m === 'string') { try { m = JSON.parse(m); } catch (err) { return; } }
    if (!m || !m.type) return;
    var mf = modalBody && modalBody.querySelector('iframe');
    if (mf && mf.contentWindow === e.source) {
      if (m.type === 'onStateChange' && m.value === 1 && !mf._ttSound) { mf._ttSound = true; ttSend(mf, 'unMute'); }
      return;
    }
    if (m.type !== 'onPlayerReady') return;
    $$('iframe[data-tt-preview]').forEach(function (f) {
      if (f.contentWindow === e.source && !f._ttOn) ttSend(f, 'pause');
    });
  });

  /* ---------- Horizontal rows (videos, reviews) prev/next ---------- */
  function initRows(root) {
    $$('[data-row-nav]', root).forEach(function (nav) {
      var row = d.getElementById(nav.getAttribute('data-row-nav'));
      if (!row) return;
      nav.addEventListener('click', function (e) {
        var b = e.target.closest('[data-dir]');
        if (!b) return;
        row.scrollBy({ left: (b.getAttribute('data-dir') === 'next' ? 1 : -1) * row.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  }

  /* ---------- Banner slider ---------- */
  function initBanners(root) {
    $$('[data-banner]', root).forEach(function (banner) {
      if (banner._init) return;
      banner._init = true;
      var track = banner.querySelector('[data-track]');
      var slides = track ? track.children : [];
      var dots = $$('[data-dot]', banner);
      if (!track || slides.length < 2) return;
      var idx = 0;
      var timer = null;
      var delay = parseInt(banner.getAttribute('data-autoplay'), 10) || 0;

      function go(i) {
        idx = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[idx].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      function setActive() {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        idx = i;
        dots.forEach(function (dot, n) { dot.classList.toggle('is-active', n === i); });
      }
      var t;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(setActive, 60); }, { passive: true });
      dots.forEach(function (dot, n) { dot.addEventListener('click', function () { go(n); restart(); }); });

      function restart() {
        if (!delay || reduceMotion) return;
        clearInterval(timer);
        timer = setInterval(function () { go(idx + 1); }, delay * 1000);
      }
      track.addEventListener('touchstart', function () { clearInterval(timer); }, { passive: true });
      track.addEventListener('touchend', restart, { passive: true });
      restart();
    });
  }

  /* ---------- Header: drawer + dropdowns ---------- */
  d.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-close-details]');
    if (closer) {
      var det = closer.closest('details');
      if (det) det.removeAttribute('open');
    }
    $$('.nav details[open], .hsearch[open]').forEach(function (det) {
      if (!det.contains(e.target)) det.removeAttribute('open');
    });
  });

  /* ---------- Strict search: opens a product only when its full name is typed ---------- */
  // Case, accents, symbols (™, emoji) and extra spaces are ignored; nothing is ever suggested or listed
  function normName(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  }
  $$('[data-strict-search]').forEach(function (det) {
    det.addEventListener('toggle', function () {
      if (det.open) { var i = det.querySelector('input'); if (i) i.focus(); }
    });
  });
  d.addEventListener('input', function (e) {
    var f = e.target.closest('[data-strict-search] form');
    if (f) f.querySelector('[data-search-msg]').hidden = true;
  });
  d.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-strict-search] form');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input');
    var msg = form.querySelector('[data-search-msg]');
    var raw = input.value.trim();
    var q = normName(raw);
    var miss = function () { msg.hidden = false; };
    if (q.length < 3) return miss();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var json = function (r) { return r.ok ? r.json() : null; };
    // 1) the product address made from the name, 2) Shopify search, keeping only an exact full-name match
    fetch(root + 'products/' + q.replace(/ /g, '-') + '.js').then(json).catch(function () { return null; })
      .then(function (p) {
        if (p && normName(p.title) === q) { location.href = root + 'products/' + p.handle; return; }
        return fetch(root + 'search/suggest.json?q=' + encodeURIComponent(raw) + '&resources[type]=product&resources[limit]=10')
          .then(json)
          .then(function (data) {
            var list = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            var hit = list.filter(function (x) { return normName(x.title) === q; })[0];
            if (hit) location.href = root + 'products/' + hit.handle; else miss();
          });
      })
      .catch(miss);
  });

  /* ---------- Quantity steppers ---------- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min, 10) || 1;
    var val = (parseInt(input.value, 10) || min) + (b.getAttribute('data-qty') === 'plus' ? 1 : -1);
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Videos: no download button, no picture-in-picture ---------- */
  function lockVideos(root) {
    $$('video', root).forEach(function (v) {
      v.setAttribute('controlslist', 'nodownload noplaybackrate');
      v.setAttribute('disablepictureinpicture', '');
    });
  }

  /* Scroll reveal, tilt, cursor, confetti and other motion live in fx.js */

  /* ---------- Moving reviews: hold to pause on phones ---------- */
  function initMarquee(root) {
    $$('[data-rv-marquee]', root).forEach(function (m) {
      if (m._mq) return;
      m._mq = true;
      m.addEventListener('touchstart', function () { m.classList.add('is-held'); }, { passive: true });
      m.addEventListener('touchend', function () { m.classList.remove('is-held'); }, { passive: true });
    });
  }

  /* ---------- Hero buttons with no link scroll to the next section ---------- */
  d.addEventListener('click', function (e) {
    var a = e.target.closest('[data-scroll-next]');
    if (!a) return;
    var sec = a.closest('.shopify-section');
    var next = sec && sec.nextElementSibling;
    if (!next) return;
    e.preventDefault();
    next.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- "Order" buttons in other sections scroll to the order form ---------- */
  d.addEventListener('click', function (e) {
    var a = e.target.closest('[data-scroll-cta]');
    if (!a || a.getAttribute('href') !== '#main') return;
    var cta = d.querySelector('.pp [data-cta]') || d.querySelector('.pp-price');
    if (!cta) return;
    e.preventDefault();
    cta.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
  });

  /* ---------- Instant links: prefetch on hover / touch (browsers without speculation rules) ---------- */
  var supportsSpec = HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules');
  if (!supportsSpec) {
    var done = {};
    var prefetch = function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.origin !== location.origin || a.target === '_blank') return;
      var p = a.pathname;
      if (done[p] || p === location.pathname || /^\/(cart|checkout|account)/.test(p) || a.hash) return;
      done[p] = true;
      var l = d.createElement('link');
      l.rel = 'prefetch';
      l.href = a.href;
      d.head.appendChild(l);
    };
    d.addEventListener('mouseover', prefetch, { passive: true });
    d.addEventListener('touchstart', prefetch, { passive: true });
  }

  /* ---------- Hero cards: swipe, or tap a side card, to bring it to the front ---------- */
  // Positions: 0 = left, 1 = front (middle), 2 = right. Tapping the front card still opens its product.
  function initHeroSwipe(root) {
    $$('[data-hero-swipe]', root).forEach(function (stage) {
      if (stage._swipe) return;
      stage._swipe = true;
      var cards = $$('.hero__card', stage);
      var n = cards.length;
      if (n < 2) return;
      var shift = function (dir) {
        cards.forEach(function (c) {
          c.setAttribute('data-pos', (parseInt(c.getAttribute('data-pos'), 10) - dir + n) % n);
        });
      };
      var sx = 0, sy = 0, down = false, swiped = false;
      stage.addEventListener('pointerdown', function (e) { down = true; swiped = false; sx = e.clientX; sy = e.clientY; });
      stage.addEventListener('pointerup', function (e) {
        if (!down) return;
        down = false;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) { swiped = true; shift(dx < 0 ? 1 : -1); }
      });
      stage.addEventListener('pointercancel', function () { down = false; });
      stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
      stage.addEventListener('click', function (e) {
        var card = e.target.closest('.hero__card');
        if (swiped) { e.preventDefault(); swiped = false; return; }
        if (!card) return;
        var pos = parseInt(card.getAttribute('data-pos'), 10);
        if (pos !== 1) { e.preventDefault(); shift(pos === 2 ? 1 : -1); }
      }, true);
    });
  }

  function initAll(root) {
    initAutoplay(root);
    initTikTok(root);
    initRows(root);
    initBanners(root);
    lockVideos(root);
    initMarquee(root);
    initHeroSwipe(root);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { initAll(d); });
  else initAll(d);

  /* Theme editor: re-init sections when they are added or changed */
  d.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
